import AccordionContainerMapper from '../components/AccordionContainer/viewer/AccordionContainer.mapper';
import AccordionItemMapper from '../components/AccordionItem/viewer/AccordionItem.mapper';
import AddressInputMapper from '../components/AddressInput/viewer/AddressInput.mapper';
import AdminLoginButtonMapper from '../components/AdminLoginButton/viewer/AdminLoginButton.mapper';
import BreadcrumbsMapper from '../components/Breadcrumbs/viewer/Breadcrumbs.mapper';
import CollapsibleTextMapper from '../components/CollapsibleText/viewer/CollapsibleText.mapper';
import CollapsibleTextSkinParams from '../components/CollapsibleText/CollapsibleText.skinParams';
import ComboBoxInputMapper from '../components/ComboBoxInput/viewer/ComboBoxInput.mapper';
import ContainerMapper from '../components/Container/viewer/Container.mapper';
import CustomElementComponentMapper from '../components/CustomElementComponent/viewer/CustomElementComponent.mapper';
import DropDownMenuMapper from '../components/DropDownMenu/viewer/DropDownMenu.mapper';
import ExpandableMenuMapper from '../components/ExpandableMenu/viewer/ExpandableMenu.mapper';
import ExternalComponentMapper from '../components/ExternalComponent/viewer/ExternalComponent.mapper';
import FacebookLikeBoxMapper from '../components/FacebookLikeBox/viewer/FacebookLikeBox.mapper';
import FastGalleryMapper from '../components/FastGallery/viewer/FastGallery.mapper';
import FastGallerySkinParams from '../components/FastGallery/FastGallery.skinParams';
import GoogleMapMapper from '../components/GoogleMap/viewer/GoogleMap.mapper';
import GridMapper from '../components/Grid/viewer/Grid.mapper';
import HamburgerCloseButtonMapper from '../components/HamburgerMenu/HamburgerCloseButton/viewer/HamburgerCloseButton.mapper';
import HamburgerMenuContainerMapper from '../components/HamburgerMenu/HamburgerMenuContainer/viewer/HamburgerMenuContainer.mapper';
import HamburgerMenuRootMapper from '../components/HamburgerMenu/HamburgerMenuRoot/viewer/HamburgerMenuRoot.mapper';
import HamburgerOpenButtonMapper from '../components/HamburgerMenu/HamburgerOpenButton/viewer/HamburgerOpenButton.mapper';
import HamburgerOverlayMapper from '../components/HamburgerMenu/HamburgerOverlay/viewer/HamburgerOverlay.mapper';
import ImageButtonMapper from '../components/ImageButton/viewer/ImageButton.mapper';
import ImageXMapper from '../components/ImageX/viewer/ImageX.mapper';
import LogoMapper from '../components/Logo/viewer/Logo.mapper';
import LottieEmbedMapper from '../components/LottieEmbed/viewer/LottieEmbed.mapper';
import MegaMenuContainerItemMapper from '../components/MegaMenuContainerItem/viewer/MegaMenuContainerItem.mapper';
import MenuMapper from '../components/Menu/viewer/Menu.mapper';
import MenuSkinParams from '../components/Menu/Menu.skinParams';
import MenuContainerMapper from '../components/MenuContainer/viewer/MenuContainer.mapper';
import MenuToggleMapper from '../components/MenuToggle/viewer/MenuToggle.mapper';
import MultiStateBoxMapper from '../components/MultiStateBox/viewer/MultiStateBox.mapper';
import MatrixGalleryMapper from '../components/NativeGalleries/MatrixGallery/viewer/MatrixGallery.mapper';
import PaginatedGridGalleryMapper from '../components/NativeGalleries/PaginatedGridGallery/viewer/PaginatedGridGallery.mapper';
import SliderGalleryMapper from '../components/NativeGalleries/SliderGallery/viewer/SliderGallery.mapper';
import SlideShowGalleryMapper from '../components/NativeGalleries/SlideShowGallery/viewer/SlideShowGallery.mapper';
import PaginationMapper from '../components/Pagination/viewer/Pagination.mapper';
import PopoverMenuMapper from '../components/PopoverMenu/viewer/PopoverMenu.mapper';
import PopupCloseIconButtonMapper from '../components/PopupCloseIconButton/viewer/PopupCloseIconButton.mapper';
import ProGalleryMapper from '../components/ProGallery/viewer/ProGallery.mapper';
import ProgressBarMapper from '../components/ProgressBar/viewer/ProgressBar.mapper';
import RangeSliderMapper from '../components/RangeSlider/viewer/RangeSlider.mapper';
import RepeaterMapper from '../components/Repeater/viewer/Repeater.mapper';
import ResponsiveBoxMapper from '../components/ResponsiveBox/viewer/ResponsiveBox.mapper';
import RichContentViewerMapper from '../components/RichContentViewer/viewer/RichContentViewer.mapper';
import SelectableContainerMapper from '../components/SelectableContainer/viewer/SelectableContainer.mapper';
import SelectableContainerInputMapper from '../components/SelectableContainerInput/viewer/SelectableContainerInput.mapper';
import ShareButtonsMapper from '../components/ShareButtons/viewer/ShareButtons.mapper';
import SingleTabMapper from '../components/SingleTab/viewer/SingleTab.mapper';
import SiteButtonMapper from '../components/SiteButton/viewer/SiteButton.mapper';
import SliderMapper from '../components/Slider/viewer/Slider.mapper';
import SlideshowMapper from '../components/Slideshow/Slideshow/viewer/Slideshow.mapper';
import SlideshowButtonMapper from '../components/Slideshow/SlideshowButton/viewer/SlideshowButton.mapper';
import SlideShowContainerMapper from '../components/SlideShowContainer/viewer/SlideShowContainer.mapper';
import SlideshowIndicatorMapper from '../components/SlideshowIndicator/viewer/SlideshowIndicator.mapper';
import SlideShowSlideMapper from '../components/SlideShowSlide/viewer/SlideShowSlide.mapper';
import SlotsPlaceholderMapper from '../components/SlotsPlaceholder/viewer/SlotsPlaceholder.mapper';
import StateBoxMapper from '../components/StateBox/viewer/StateBox.mapper';
import StretchedContainerMapper from '../components/StretchedContainer/viewer/StretchedContainer.mapper';
import StripColumnsContainerMapper from '../components/StripColumnsContainer/viewer/StripColumnsContainer.mapper';
import StylableButtonMapper from '../components/StylableButton/viewer/StylableButton.mapper';
import StylableButtonSkinParams from '../components/StylableButton/StylableButton.skinParams';
import StylableHorizontalMenuMapper from '../components/StylableHorizontalMenu/viewer/StylableHorizontalMenu.mapper';
import SubmenuMapper from '../components/Submenu/viewer/Submenu.mapper';
import SubmenuSkinParams from '../components/Submenu/Submenu.skinParams';
import TabsMapper from '../components/Tabs/viewer/Tabs.mapper';
import TestCompMapper from '../components/TestComp/viewer/TestComp.mapper';
import TestCompSkinParams from '../components/TestComp/TestComp.skinParams';
import TextMarqueeMapper from '../components/TextMarquee/viewer/TextMarquee.mapper';
import TextMaskMapper from '../components/TextMask/viewer/TextMask.mapper';
import TinyMenuMapper from '../components/TinyMenu/viewer/TinyMenu.mapper';
import ToggleSwitchMapper from '../components/ToggleSwitch/viewer/ToggleSwitch.mapper';
import VectorImageMapper from '../components/VectorImage/viewer/VectorImage.mapper';
import VerticalAnchorsMenuMapper from '../components/VerticalAnchorsMenu/viewer/VerticalAnchorsMenu.mapper';
import VerticalMenuMapper from '../components/VerticalMenu/viewer/VerticalMenu.mapper';
import WRichTextMapper from '../components/WRichText/viewer/WRichText.mapper';
import SvgImageSkinParams from '../components/SvgImage/SvgImage.skinParams';
import AccordionMapper from '@wix/thunderbolt-elements/src/components/Accordion/viewer/Accordion.mapper';
import AnchorMapper from '@wix/thunderbolt-elements/src/components/Anchor/viewer/Anchor.mapper';
import AudioPlayerMapper from '@wix/thunderbolt-elements/src/components/AudioPlayer/viewer/AudioPlayer.mapper';
import BackToTopButtonMapper from '@wix/thunderbolt-elements/src/components/BackToTopButton/viewer/BackToTopButton.mapper';
import CaptchaMapper from '@wix/thunderbolt-elements/src/components/Captcha/viewer/Captcha.mapper';
import CheckboxMapper from '@wix/thunderbolt-elements/src/components/Checkbox/viewer/Checkbox.mapper';
import CheckboxGroupMapper from '@wix/thunderbolt-elements/src/components/CheckboxGroup/viewer/CheckboxGroup.mapper';
import ClassicSectionMapper from '@wix/thunderbolt-elements/src/components/ClassicSection/viewer/ClassicSection.mapper';
import CollageMapper from '@wix/thunderbolt-elements/src/components/Collage/viewer/Collage.mapper';
import ColumnMapper from '@wix/thunderbolt-elements/src/components/Column/viewer/Column.mapper';
import ComboBoxInputListModalMapper from '@wix/thunderbolt-elements/src/components/ComboBoxInputListModal/viewer/ComboBoxInputListModal.mapper';
import DatePickerMapper from '@wix/thunderbolt-elements/src/components/DatePicker/viewer/DatePicker.mapper';
import DatePickerCalendarMapper from '@wix/thunderbolt-elements/src/components/DatePickerCalendar/viewer/DatePickerCalendar.mapper';
import DisqusCommentsMapper from '@wix/thunderbolt-elements/src/components/DisqusComments/viewer/DisqusComments.mapper';
import DocumentMediaMapper from '@wix/thunderbolt-elements/src/components/DocumentMedia/viewer/DocumentMedia.mapper';
import FacebookShareMapper from '@wix/thunderbolt-elements/src/components/FacebookShare/viewer/FacebookShare.mapper';
import FileUploaderMapper from '@wix/thunderbolt-elements/src/components/FileUploader/viewer/FileUploader.mapper';
import FiveGridLineMapper from '@wix/thunderbolt-elements/src/components/FiveGridLine/viewer/FiveGridLine.mapper';
import FlashComponentMapper from '@wix/thunderbolt-elements/src/components/FlashComponent/viewer/FlashComponent.mapper';
import FlickrBadgeWidgetMapper from '@wix/thunderbolt-elements/src/components/FlickrBadgeWidget/viewer/FlickrBadgeWidget.mapper';
import FooterContainerMapper from '@wix/thunderbolt-elements/src/components/FooterContainer/viewer/FooterContainer.mapper';
import CoBrandingBannerDesktopMapper from '@wix/thunderbolt-elements/src/components/FreemiumBanner/CoBrandingBannerDesktop/viewer/CoBrandingBannerDesktop.mapper';
import CoBrandingBannerMobileMapper from '@wix/thunderbolt-elements/src/components/FreemiumBanner/CoBrandingBannerMobile/viewer/CoBrandingBannerMobile.mapper';
import FreemiumBannerDesktopMapper from '@wix/thunderbolt-elements/src/components/FreemiumBanner/FreemiumBannerDesktop/viewer/FreemiumBannerDesktop.mapper';
import FreemiumBannerMobileMapper from '@wix/thunderbolt-elements/src/components/FreemiumBanner/FreemiumBannerMobile/viewer/FreemiumBannerMobile.mapper';
import FreemiumBannerResponsiveMapper from '@wix/thunderbolt-elements/src/components/FreemiumBanner/FreemiumBannerResponsive/viewer/FreemiumBannerResponsive.mapper';
import FreestyleMapper from '@wix/thunderbolt-elements/src/components/Freestyle/viewer/Freestyle.mapper';
import HeaderContainerMapper from '@wix/thunderbolt-elements/src/components/HeaderContainer/viewer/HeaderContainer.mapper';
import HoneycombMapper from '@wix/thunderbolt-elements/src/components/Honeycomb/viewer/Honeycomb.mapper';
import HtmlComponentMapper from '@wix/thunderbolt-elements/src/components/HtmlComponent/viewer/HtmlComponent.mapper';
import ImpressMapper from '@wix/thunderbolt-elements/src/components/Impress/viewer/Impress.mapper';
import ItunesButtonMapper from '@wix/thunderbolt-elements/src/components/ItunesButton/viewer/ItunesButton.mapper';
import LanguageSelectorMapper from '@wix/thunderbolt-elements/src/components/LanguageSelector/viewer/LanguageSelector.mapper';
import LineShareButtonMapper from '@wix/thunderbolt-elements/src/components/LineShareButton/viewer/LineShareButton.mapper';
import LinkBarMapper from '@wix/thunderbolt-elements/src/components/LinkBar/viewer/LinkBar.mapper';
import LoginButtonMapper from '@wix/thunderbolt-elements/src/components/LoginButton/viewer/LoginButton.mapper';
import LoginSocialBarMapper from '@wix/thunderbolt-elements/src/components/LoginSocialBar/viewer/LoginSocialBar.mapper';
import MasonryMapper from '@wix/thunderbolt-elements/src/components/Masonry/viewer/Masonry.mapper';
import HoverBoxMapper from '@wix/thunderbolt-elements/src/components/MediaContainers/HoverBox/viewer/HoverBox.mapper';
import MediaContainerMapper from '@wix/thunderbolt-elements/src/components/MediaContainers/MediaContainer/viewer/MediaContainer.mapper';
import MusicPlayerMapper from '@wix/thunderbolt-elements/src/components/MusicPlayer/viewer/MusicPlayer.mapper';
import PayPalButtonMapper from '@wix/thunderbolt-elements/src/components/PayPalButton/viewer/PayPalButton.mapper';
import PinItPinWidgetMapper from '@wix/thunderbolt-elements/src/components/PinItPinWidget/viewer/PinItPinWidget.mapper';
import PinterestFollowMapper from '@wix/thunderbolt-elements/src/components/PinterestFollow/viewer/PinterestFollow.mapper';
import PinterestPinItMapper from '@wix/thunderbolt-elements/src/components/PinterestPinIt/viewer/PinterestPinIt.mapper';
import PopupContainerMapper from '@wix/thunderbolt-elements/src/components/PopupContainer/viewer/PopupContainer.mapper';
import QuickActionBarMapper from '@wix/thunderbolt-elements/src/components/QuickActionBar/viewer/QuickActionBar.mapper';
import RadioGroupMapper from '@wix/thunderbolt-elements/src/components/RadioGroup/viewer/RadioGroup.mapper';
import RatingsDisplayMapper from '@wix/thunderbolt-elements/src/components/RatingsDisplay/viewer/RatingsDisplay.mapper';
import RatingsInputMapper from '@wix/thunderbolt-elements/src/components/RatingsInput/viewer/RatingsInput.mapper';
import ResponsivePopupContainerMapper from '@wix/thunderbolt-elements/src/components/ResponsivePopupContainer/viewer/ResponsivePopupContainer.mapper';
import RichTextBoxMapper from '@wix/thunderbolt-elements/src/components/RichTextBox/viewer/RichTextBox.mapper';
import RSSButtonMapper from '@wix/thunderbolt-elements/src/components/RSSButton/viewer/RSSButton.mapper';
import SearchBoxMapper from '@wix/thunderbolt-elements/src/components/SearchBox/viewer/SearchBox.mapper';
import HeaderSectionMapper from '@wix/thunderbolt-elements/src/components/Sections/HeaderSection/viewer/HeaderSection.mapper';
import SectionMapper from '@wix/thunderbolt-elements/src/components/Sections/Section/viewer/Section.mapper';
import SelectionTagsListMapper from '@wix/thunderbolt-elements/src/components/SelectionTagsList/viewer/SelectionTagsList.mapper';
import SeoTpaGalleryMapper from '@wix/thunderbolt-elements/src/components/SeoTpaGallery/viewer/SeoTpaGallery.mapper';
import SignatureInputMapper from '@wix/thunderbolt-elements/src/components/SignatureInput/viewer/SignatureInput.mapper';
import SingleAudioPlayerMapper from '@wix/thunderbolt-elements/src/components/SingleAudioPlayer/viewer/SingleAudioPlayer.mapper';
import SkipToContentButtonMapper from '@wix/thunderbolt-elements/src/components/SkipToContentButton/viewer/SkipToContentButton.mapper';
import SocialAuthMapper from '@wix/thunderbolt-elements/src/components/SocialAuth/viewer/SocialAuth.mapper';
import SoundCloudWidgetMapper from '@wix/thunderbolt-elements/src/components/SoundCloudWidget/viewer/SoundCloudWidget.mapper';
import SpotifyFollowMapper from '@wix/thunderbolt-elements/src/components/SpotifyFollow/viewer/SpotifyFollow.mapper';
import SpotifyPlayerMapper from '@wix/thunderbolt-elements/src/components/SpotifyPlayer/viewer/SpotifyPlayer.mapper';
import StripShowcaseMapper from '@wix/thunderbolt-elements/src/components/StripShowcase/viewer/StripShowcase.mapper';
import StripSlideshowMapper from '@wix/thunderbolt-elements/src/components/StripSlideshow/viewer/StripSlideshow.mapper';
import TextAreaInputMapper from '@wix/thunderbolt-elements/src/components/TextAreaInput/viewer/TextAreaInput.mapper';
import TextInputMapper from '@wix/thunderbolt-elements/src/components/TextInput/viewer/TextInput.mapper';
import ThumbnailsMapper from '@wix/thunderbolt-elements/src/components/Thumbnails/viewer/Thumbnails.mapper';
import TimePickerMapper from '@wix/thunderbolt-elements/src/components/TimePicker/viewer/TimePicker.mapper';
import TPA3DCarouselMapper from '@wix/thunderbolt-elements/src/components/TPA3DCarousel/viewer/TPA3DCarousel.mapper';
import TPA3DGalleryMapper from '@wix/thunderbolt-elements/src/components/TPA3DGallery/viewer/TPA3DGallery.mapper';
import VerticalLineMapper from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/VerticalLine.mapper';
import MediaPlayerMapper from '@wix/thunderbolt-elements/src/components/VideoBoxContainer/VideoBox/viewer/VideoBox.mapper';
import MediaControlsMapper from '@wix/thunderbolt-elements/src/components/VideoBoxContainer/VideoBoxAudio/viewer/VideoBoxAudio.mapper';
import MediaOverlayControlsMapper from '@wix/thunderbolt-elements/src/components/VideoBoxContainer/VideoBoxPlay/viewer/VideoBoxPlay.mapper';
import VideoMapper from '@wix/thunderbolt-elements/src/components/VideoLegacy/viewer/VideoLegacy.mapper';
import VideoPlayerMapper from '@wix/thunderbolt-elements/src/components/VideoPlayer/viewer/VideoPlayer.mapper';
import VKShareButtonMapper from '@wix/thunderbolt-elements/src/components/VKShareButton/viewer/VKShareButton.mapper';
import WFacebookCommentMapper from '@wix/thunderbolt-elements/src/components/WFacebookComment/viewer/WFacebookComment.mapper';
import WFacebookLikeMapper from '@wix/thunderbolt-elements/src/components/WFacebookLike/viewer/WFacebookLike.mapper';
import WPhotoMapper from '@wix/thunderbolt-elements/src/components/WPhoto/viewer/WPhoto.mapper';
import WTwitterFollowMapper from '@wix/thunderbolt-elements/src/components/WTwitterFollow/viewer/WTwitterFollow.mapper';
import WTwitterTweetMapper from '@wix/thunderbolt-elements/src/components/WTwitterTweet/viewer/WTwitterTweet.mapper';
import YouTubeSubscribeButtonMapper from '@wix/thunderbolt-elements/src/components/YouTubeSubscribeButton/viewer/YouTubeSubscribeButton.mapper';
import MeshGroupMapper from '@wix/thunderbolt-elements/src/thunderbolt-core-components/MeshGroup/viewer/MeshGroup.mapper';
import LeanTestComponentMapper from '../.components/LeanTestComponent/viewer/LeanTestComponent.mapper';
import SimpleCardMapper from '../.components/SimpleCard/viewer/SimpleCard.mapper';
import StepperMapper from '../.components/Stepper/viewer/Stepper.mapper';


const AccordionContainer = {
  mapper: AccordionContainerMapper
};

const AccordionItem = {
  mapper: AccordionItemMapper
};

const AddressInput = {
  mapper: AddressInputMapper
};

const AdminLoginButton = {
  mapper: AdminLoginButtonMapper
};

const Breadcrumbs = {
  mapper: BreadcrumbsMapper
};

const CollapsibleText = {
  mapper: CollapsibleTextMapper,
  skinParams: CollapsibleTextSkinParams
};

const ComboBoxInput = {
  mapper: ComboBoxInputMapper
};

const Container = {
  mapper: ContainerMapper
};

const CustomElementComponent = {
  mapper: CustomElementComponentMapper
};

const DropDownMenu = {
  mapper: DropDownMenuMapper
};

const ExpandableMenu = {
  mapper: ExpandableMenuMapper
};

const ExternalComponent = {
  mapper: ExternalComponentMapper
};

const FacebookLikeBox = {
  mapper: FacebookLikeBoxMapper
};

const FastGallery = {
  mapper: FastGalleryMapper,
  skinParams: FastGallerySkinParams
};

const GoogleMap = {
  mapper: GoogleMapMapper
};

const Grid = {
  mapper: GridMapper
};

const HamburgerCloseButton = {
  mapper: HamburgerCloseButtonMapper
};

const HamburgerMenuContainer = {
  mapper: HamburgerMenuContainerMapper
};

const HamburgerMenuRoot = {
  mapper: HamburgerMenuRootMapper
};

const HamburgerOpenButton = {
  mapper: HamburgerOpenButtonMapper
};

const HamburgerOverlay = {
  mapper: HamburgerOverlayMapper
};

const ImageButton = {
  mapper: ImageButtonMapper
};

const ImageX = {
  mapper: ImageXMapper
};

const Logo = {
  mapper: LogoMapper
};

const LottieEmbed = {
  mapper: LottieEmbedMapper
};

const MegaMenuContainerItem = {
  mapper: MegaMenuContainerItemMapper
};

const Menu = {
  mapper: MenuMapper,
  skinParams: MenuSkinParams
};

const MenuContainer = {
  mapper: MenuContainerMapper
};

const MenuToggle = {
  mapper: MenuToggleMapper
};

const MultiStateBox = {
  mapper: MultiStateBoxMapper
};

const MatrixGallery = {
  mapper: MatrixGalleryMapper
};

const PaginatedGridGallery = {
  mapper: PaginatedGridGalleryMapper
};

const SliderGallery = {
  mapper: SliderGalleryMapper
};

const SlideShowGallery = {
  mapper: SlideShowGalleryMapper
};

const Pagination = {
  mapper: PaginationMapper
};

const PopoverMenu = {
  mapper: PopoverMenuMapper
};

const PopupCloseIconButton = {
  mapper: PopupCloseIconButtonMapper
};

const ProGallery = {
  mapper: ProGalleryMapper
};

const ProgressBar = {
  mapper: ProgressBarMapper
};

const RangeSlider = {
  mapper: RangeSliderMapper
};

const Repeater = {
  mapper: RepeaterMapper
};

const ResponsiveBox = {
  mapper: ResponsiveBoxMapper
};

const RichContentViewer = {
  mapper: RichContentViewerMapper
};

const SelectableContainer = {
  mapper: SelectableContainerMapper
};

const SelectableContainerInput = {
  mapper: SelectableContainerInputMapper
};

const ShareButtons = {
  mapper: ShareButtonsMapper
};

const SingleTab = {
  mapper: SingleTabMapper
};

const SiteButton = {
  mapper: SiteButtonMapper
};

const Slider = {
  mapper: SliderMapper
};

const Slideshow = {
  mapper: SlideshowMapper
};

const SlideshowButton = {
  mapper: SlideshowButtonMapper
};

const SlideShowContainer = {
  mapper: SlideShowContainerMapper
};

const SlideshowIndicator = {
  mapper: SlideshowIndicatorMapper
};

const SlideShowSlide = {
  mapper: SlideShowSlideMapper
};

const SlotsPlaceholder = {
  mapper: SlotsPlaceholderMapper
};

const StateBox = {
  mapper: StateBoxMapper
};

const StretchedContainer = {
  mapper: StretchedContainerMapper
};

const StripColumnsContainer = {
  mapper: StripColumnsContainerMapper
};

const StylableButton = {
  mapper: StylableButtonMapper,
  skinParams: StylableButtonSkinParams
};

const StylableHorizontalMenu = {
  mapper: StylableHorizontalMenuMapper
};

const Submenu = {
  mapper: SubmenuMapper,
  skinParams: SubmenuSkinParams
};

const Tabs = {
  mapper: TabsMapper
};

const TestComp = {
  mapper: TestCompMapper,
  skinParams: TestCompSkinParams
};

const TextMarquee = {
  mapper: TextMarqueeMapper
};

const TextMask = {
  mapper: TextMaskMapper
};

const TinyMenu = {
  mapper: TinyMenuMapper
};

const ToggleSwitch = {
  mapper: ToggleSwitchMapper
};

const VectorImage = {
  mapper: VectorImageMapper
};

const VerticalAnchorsMenu = {
  mapper: VerticalAnchorsMenuMapper
};

const VerticalMenu = {
  mapper: VerticalMenuMapper
};

const WRichText = {
  mapper: WRichTextMapper
};

const SvgImage = {
  skinParams: SvgImageSkinParams
};

const Accordion = {
  mapper: AccordionMapper
};

const Anchor = {
  mapper: AnchorMapper
};

const AudioPlayer = {
  mapper: AudioPlayerMapper
};

const BackToTopButton = {
  mapper: BackToTopButtonMapper
};

const Captcha = {
  mapper: CaptchaMapper
};

const Checkbox = {
  mapper: CheckboxMapper
};

const CheckboxGroup = {
  mapper: CheckboxGroupMapper
};

const ClassicSection = {
  mapper: ClassicSectionMapper
};

const Collage = {
  mapper: CollageMapper
};

const Column = {
  mapper: ColumnMapper
};

const ComboBoxInputListModal = {
  mapper: ComboBoxInputListModalMapper
};

const DatePicker = {
  mapper: DatePickerMapper
};

const DatePickerCalendar = {
  mapper: DatePickerCalendarMapper
};

const DisqusComments = {
  mapper: DisqusCommentsMapper
};

const DocumentMedia = {
  mapper: DocumentMediaMapper
};

const FacebookShare = {
  mapper: FacebookShareMapper
};

const FileUploader = {
  mapper: FileUploaderMapper
};

const FiveGridLine = {
  mapper: FiveGridLineMapper
};

const FlashComponent = {
  mapper: FlashComponentMapper
};

const FlickrBadgeWidget = {
  mapper: FlickrBadgeWidgetMapper
};

const FooterContainer = {
  mapper: FooterContainerMapper
};

const CoBrandingBannerDesktop = {
  mapper: CoBrandingBannerDesktopMapper
};

const CoBrandingBannerMobile = {
  mapper: CoBrandingBannerMobileMapper
};

const FreemiumBannerDesktop = {
  mapper: FreemiumBannerDesktopMapper
};

const FreemiumBannerMobile = {
  mapper: FreemiumBannerMobileMapper
};

const FreemiumBannerResponsive = {
  mapper: FreemiumBannerResponsiveMapper
};

const Freestyle = {
  mapper: FreestyleMapper
};

const HeaderContainer = {
  mapper: HeaderContainerMapper
};

const Honeycomb = {
  mapper: HoneycombMapper
};

const HtmlComponent = {
  mapper: HtmlComponentMapper
};

const Impress = {
  mapper: ImpressMapper
};

const ItunesButton = {
  mapper: ItunesButtonMapper
};

const LanguageSelector = {
  mapper: LanguageSelectorMapper
};

const LineShareButton = {
  mapper: LineShareButtonMapper
};

const LinkBar = {
  mapper: LinkBarMapper
};

const LoginButton = {
  mapper: LoginButtonMapper
};

const LoginSocialBar = {
  mapper: LoginSocialBarMapper
};

const Masonry = {
  mapper: MasonryMapper
};

const HoverBox = {
  mapper: HoverBoxMapper
};

const MediaContainer = {
  mapper: MediaContainerMapper
};

const MusicPlayer = {
  mapper: MusicPlayerMapper
};

const PayPalButton = {
  mapper: PayPalButtonMapper
};

const PinItPinWidget = {
  mapper: PinItPinWidgetMapper
};

const PinterestFollow = {
  mapper: PinterestFollowMapper
};

const PinterestPinIt = {
  mapper: PinterestPinItMapper
};

const PopupContainer = {
  mapper: PopupContainerMapper
};

const QuickActionBar = {
  mapper: QuickActionBarMapper
};

const RadioGroup = {
  mapper: RadioGroupMapper
};

const RatingsDisplay = {
  mapper: RatingsDisplayMapper
};

const RatingsInput = {
  mapper: RatingsInputMapper
};

const ResponsivePopupContainer = {
  mapper: ResponsivePopupContainerMapper
};

const RichTextBox = {
  mapper: RichTextBoxMapper
};

const RSSButton = {
  mapper: RSSButtonMapper
};

const SearchBox = {
  mapper: SearchBoxMapper
};

const HeaderSection = {
  mapper: HeaderSectionMapper
};

const Section = {
  mapper: SectionMapper
};

const SelectionTagsList = {
  mapper: SelectionTagsListMapper
};

const SeoTpaGallery = {
  mapper: SeoTpaGalleryMapper
};

const SignatureInput = {
  mapper: SignatureInputMapper
};

const SingleAudioPlayer = {
  mapper: SingleAudioPlayerMapper
};

const SkipToContentButton = {
  mapper: SkipToContentButtonMapper
};

const SocialAuth = {
  mapper: SocialAuthMapper
};

const SoundCloudWidget = {
  mapper: SoundCloudWidgetMapper
};

const SpotifyFollow = {
  mapper: SpotifyFollowMapper
};

const SpotifyPlayer = {
  mapper: SpotifyPlayerMapper
};

const StripShowcase = {
  mapper: StripShowcaseMapper
};

const StripSlideshow = {
  mapper: StripSlideshowMapper
};

const TextAreaInput = {
  mapper: TextAreaInputMapper
};

const TextInput = {
  mapper: TextInputMapper
};

const Thumbnails = {
  mapper: ThumbnailsMapper
};

const TimePicker = {
  mapper: TimePickerMapper
};

const TPA3DCarousel = {
  mapper: TPA3DCarouselMapper
};

const TPA3DGallery = {
  mapper: TPA3DGalleryMapper
};

const VerticalLine = {
  mapper: VerticalLineMapper
};

const MediaPlayer = {
  mapper: MediaPlayerMapper
};

const MediaControls = {
  mapper: MediaControlsMapper
};

const MediaOverlayControls = {
  mapper: MediaOverlayControlsMapper
};

const Video = {
  mapper: VideoMapper
};

const VideoPlayer = {
  mapper: VideoPlayerMapper
};

const VKShareButton = {
  mapper: VKShareButtonMapper
};

const WFacebookComment = {
  mapper: WFacebookCommentMapper
};

const WFacebookLike = {
  mapper: WFacebookLikeMapper
};

const WPhoto = {
  mapper: WPhotoMapper
};

const WTwitterFollow = {
  mapper: WTwitterFollowMapper
};

const WTwitterTweet = {
  mapper: WTwitterTweetMapper
};

const YouTubeSubscribeButton = {
  mapper: YouTubeSubscribeButtonMapper
};

const MeshGroup = {
  mapper: MeshGroupMapper
};

const LeanTestComponent = {
  mapper: LeanTestComponentMapper
};

const SimpleCard = {
  mapper: SimpleCardMapper
};

const Stepper = {
  mapper: StepperMapper
};


export const components = {
  ['AccordionContainer']: AccordionContainer,
  ['AccordionItem']: AccordionItem,
  ['AddressInput']: AddressInput,
  ['AdminLoginButton']: AdminLoginButton,
  ['Breadcrumbs']: Breadcrumbs,
  ['CollapsibleText']: CollapsibleText,
  ['ComboBoxInput']: ComboBoxInput,
  ['Container']: Container,
  ['CustomElementComponent']: CustomElementComponent,
  ['DropDownMenu']: DropDownMenu,
  ['ExpandableMenu']: ExpandableMenu,
  ['ExternalComponent']: ExternalComponent,
  ['FacebookLikeBox']: FacebookLikeBox,
  ['FastGallery']: FastGallery,
  ['GoogleMap']: GoogleMap,
  ['Grid']: Grid,
  ['HamburgerCloseButton']: HamburgerCloseButton,
  ['HamburgerMenuContainer']: HamburgerMenuContainer,
  ['HamburgerMenuRoot']: HamburgerMenuRoot,
  ['HamburgerOpenButton']: HamburgerOpenButton,
  ['HamburgerOverlay']: HamburgerOverlay,
  ['ImageButton']: ImageButton,
  ['ImageX']: ImageX,
  ['Logo']: Logo,
  ['LottieEmbed']: LottieEmbed,
  ['MegaMenuContainerItem']: MegaMenuContainerItem,
  ['Menu']: Menu,
  ['MenuContainer']: MenuContainer,
  ['MenuToggle']: MenuToggle,
  ['MultiStateBox']: MultiStateBox,
  ['MatrixGallery']: MatrixGallery,
  ['PaginatedGridGallery']: PaginatedGridGallery,
  ['SliderGallery']: SliderGallery,
  ['SlideShowGallery']: SlideShowGallery,
  ['Pagination']: Pagination,
  ['PopoverMenu']: PopoverMenu,
  ['PopupCloseIconButton']: PopupCloseIconButton,
  ['ProGallery']: ProGallery,
  ['ProgressBar']: ProgressBar,
  ['RangeSlider']: RangeSlider,
  ['Repeater']: Repeater,
  ['ResponsiveBox']: ResponsiveBox,
  ['RichContentViewer']: RichContentViewer,
  ['SelectableContainer']: SelectableContainer,
  ['SelectableContainerInput']: SelectableContainerInput,
  ['ShareButtons']: ShareButtons,
  ['SingleTab']: SingleTab,
  ['SiteButton']: SiteButton,
  ['Slider']: Slider,
  ['Slideshow']: Slideshow,
  ['SlideshowButton']: SlideshowButton,
  ['SlideShowContainer']: SlideShowContainer,
  ['SlideshowIndicator']: SlideshowIndicator,
  ['SlideShowSlide']: SlideShowSlide,
  ['SlotsPlaceholder']: SlotsPlaceholder,
  ['StateBox']: StateBox,
  ['StretchedContainer']: StretchedContainer,
  ['StripColumnsContainer']: StripColumnsContainer,
  ['StylableButton']: StylableButton,
  ['StylableHorizontalMenu']: StylableHorizontalMenu,
  ['Submenu']: Submenu,
  ['Tabs']: Tabs,
  ['TestComp']: TestComp,
  ['TextMarquee']: TextMarquee,
  ['TextMask']: TextMask,
  ['TinyMenu']: TinyMenu,
  ['ToggleSwitch']: ToggleSwitch,
  ['VectorImage']: VectorImage,
  ['VerticalAnchorsMenu']: VerticalAnchorsMenu,
  ['VerticalMenu']: VerticalMenu,
  ['WRichText']: WRichText,
  ['SvgImage']: SvgImage,
  ['Accordion']: Accordion,
  ['Anchor']: Anchor,
  ['AudioPlayer']: AudioPlayer,
  ['BackToTopButton']: BackToTopButton,
  ['Captcha']: Captcha,
  ['Checkbox']: Checkbox,
  ['CheckboxGroup']: CheckboxGroup,
  ['ClassicSection']: ClassicSection,
  ['Collage']: Collage,
  ['Column']: Column,
  ['ComboBoxInputListModal']: ComboBoxInputListModal,
  ['DatePicker']: DatePicker,
  ['DatePickerCalendar']: DatePickerCalendar,
  ['DisqusComments']: DisqusComments,
  ['DocumentMedia']: DocumentMedia,
  ['FacebookShare']: FacebookShare,
  ['FileUploader']: FileUploader,
  ['FiveGridLine']: FiveGridLine,
  ['FlashComponent']: FlashComponent,
  ['FlickrBadgeWidget']: FlickrBadgeWidget,
  ['FooterContainer']: FooterContainer,
  ['CoBrandingBannerDesktop']: CoBrandingBannerDesktop,
  ['CoBrandingBannerMobile']: CoBrandingBannerMobile,
  ['FreemiumBannerDesktop']: FreemiumBannerDesktop,
  ['FreemiumBannerMobile']: FreemiumBannerMobile,
  ['FreemiumBannerResponsive']: FreemiumBannerResponsive,
  ['Freestyle']: Freestyle,
  ['HeaderContainer']: HeaderContainer,
  ['Honeycomb']: Honeycomb,
  ['HtmlComponent']: HtmlComponent,
  ['Impress']: Impress,
  ['ItunesButton']: ItunesButton,
  ['LanguageSelector']: LanguageSelector,
  ['LineShareButton']: LineShareButton,
  ['LinkBar']: LinkBar,
  ['LoginButton']: LoginButton,
  ['LoginSocialBar']: LoginSocialBar,
  ['Masonry']: Masonry,
  ['HoverBox']: HoverBox,
  ['MediaContainer']: MediaContainer,
  ['MusicPlayer']: MusicPlayer,
  ['PayPalButton']: PayPalButton,
  ['PinItPinWidget']: PinItPinWidget,
  ['PinterestFollow']: PinterestFollow,
  ['PinterestPinIt']: PinterestPinIt,
  ['PopupContainer']: PopupContainer,
  ['QuickActionBar']: QuickActionBar,
  ['RadioGroup']: RadioGroup,
  ['RatingsDisplay']: RatingsDisplay,
  ['RatingsInput']: RatingsInput,
  ['ResponsivePopupContainer']: ResponsivePopupContainer,
  ['RichTextBox']: RichTextBox,
  ['RSSButton']: RSSButton,
  ['SearchBox']: SearchBox,
  ['HeaderSection']: HeaderSection,
  ['Section']: Section,
  ['SelectionTagsList']: SelectionTagsList,
  ['SeoTpaGallery']: SeoTpaGallery,
  ['SignatureInput']: SignatureInput,
  ['SingleAudioPlayer']: SingleAudioPlayer,
  ['SkipToContentButton']: SkipToContentButton,
  ['SocialAuth']: SocialAuth,
  ['SoundCloudWidget']: SoundCloudWidget,
  ['SpotifyFollow']: SpotifyFollow,
  ['SpotifyPlayer']: SpotifyPlayer,
  ['StripShowcase']: StripShowcase,
  ['StripSlideshow']: StripSlideshow,
  ['TextAreaInput']: TextAreaInput,
  ['TextInput']: TextInput,
  ['Thumbnails']: Thumbnails,
  ['TimePicker']: TimePicker,
  ['TPA3DCarousel']: TPA3DCarousel,
  ['TPA3DGallery']: TPA3DGallery,
  ['VerticalLine']: VerticalLine,
  ['MediaPlayer']: MediaPlayer,
  ['MediaControls']: MediaControls,
  ['MediaOverlayControls']: MediaOverlayControls,
  ['Video']: Video,
  ['VideoPlayer']: VideoPlayer,
  ['VKShareButton']: VKShareButton,
  ['WFacebookComment']: WFacebookComment,
  ['WFacebookLike']: WFacebookLike,
  ['WPhoto']: WPhoto,
  ['WTwitterFollow']: WTwitterFollow,
  ['WTwitterTweet']: WTwitterTweet,
  ['YouTubeSubscribeButton']: YouTubeSubscribeButton,
  ['MeshGroup']: MeshGroup,
  ['LeanTestComponent']: LeanTestComponent,
  ['SimpleCard']: SimpleCard,
  ['Stepper']: Stepper
};

